
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/coaching/program",
      function () {
        return require("private-next-pages/coaching/program.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/coaching/program"])
      });
    }
  